import { Button, Card, Header, Image, Label } from "semantic-ui-react"
import React, { useState } from "react"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { searchVehicleByVin, selectVehicle } from "../../../v1/actions/vehicles"
import store from "../../../shared_component/utils/configureStore"
import placeholderCarImg from "../../../images/placeholder_car.svg"
import { routerPaths } from "../../../v1/constants/paths"
import { withRouter } from "react-router-dom"
import { getPopularServices } from "../../../v1/actions/services"
import { updateCart } from "../../../v1/actions/user"
import Notifications from "../../../v1/components/Notifications"
import {
  gaJSON,
  serviceSelectedEvents,
  trackFirebaseAnalytics
} from "../../../shared_component/utils/googleAnalyticsHelpers"

const VehicleInfo = ({ t, history, location, user, vehicle, handleSearchAgain, cart }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const queryParams = new URLSearchParams(location.search)
  const isOilChangeService = queryParams.get("oil_change") || ""

  const handleToggleVehicleInfo = async () => {
    await store.dispatch(selectVehicle({}))
    handleSearchAgain()
    trackFirebaseAnalytics({
      event: gaJSON.EtoB_not_my_vehicle_click
    })
  }

  const handleVehicleSubmit = async () => {
    trackFirebaseAnalytics({
      event: gaJSON.EtoB_it_is_my_vehicle_click
    })
    setIsSubmitting(true)
    if (vehicle.id === user.activeVehicleId) {
      history.push({
        pathname: routerPaths.shopSelection
      })
    } else {
      const success = await store.dispatch(searchVehicleByVin(vehicle.vin, true))
      if (typeof success === "boolean") {
        setIsSubmitting(false)
        if (isOilChangeService === "true") {
          window.location.href = "/#/service-request/shop-selection?oil_change=true"
        } else {
          history.push({
            pathname: routerPaths.addServices
          })
        }
      } else {
        trackFirebaseAnalytics({
          event: gaJSON.EtoB_vehicle_submit_error
        })
        store.dispatch(
          Notifications.error({
            title: t("errorLbl"),
            message: success.toString(),
            position: "tr",
            autoDismiss: 5,
            action: {
              label: "Dismiss"
            }
          })
        )
        setIsSubmitting(false)
      }
    }
  }

  return (
    <Card className="vehicle-info-card" raised={true}>
      <div className="vehicle-info">
        <Header as="h3">{t("isThisYourVehicle")}</Header>
        <Image src={vehicle.dashboard_url || placeholderCarImg} />
        <Label>
          {vehicle.year} {vehicle.make} {vehicle.model}
        </Label>
      </div>
      <div className="action-button">
        <Button
          fluid
          onClick={handleVehicleSubmit}
          loading={isSubmitting}
          disabled={isSubmitting}
          className="primary-button"
        >
          {t("myVehicle")}
        </Button>

        <Button
          fluid
          basic
          color="black"
          onClick={handleToggleVehicleInfo}
          loading={isSubmitting}
          disabled={isSubmitting}
          className="secondary-button"
        >
          {t("notMyVehicle")}
        </Button>
      </div>
    </Card>
  )
}

function mapStateToProps(state, props) {
  let user = state.user || {}
  let vehicle = state.selectedVehicle.selectedVehicle || {}
  let cart
  let currentActiveOrder =
    user.active_orders && user.active_orders.find((o) => o.vehicle_id == user.activeVehicleId)

  if (currentActiveOrder) {
    cart = currentActiveOrder
  } else {
    if (props.cartId) {
      cart = user.active_carts && user.active_carts.filter((c) => c.id == Number(props.cartId))[0]
    } else {
      cart =
        user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)
    }
  }

  if (!cart || !cart.order_services) {
    cart = { estimated_total: 0, order_services: [] }
  }

  return {
    user: user,
    cart: cart,
    user: user,
    vehicle
  }
}

export default withRouter(connect(mapStateToProps)(withTranslation("vehicleDetails")(VehicleInfo)))
